import React from 'react'
import { makeStyles, createStyles, Box, CardHeader, Avatar, Typography, fade } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useCustomTranslation, useAddressFormat } from 'src/hooks'
import { ReactComponent as ImageFillIcon } from 'src/mobile/assets/icons/image-fill.svg'
import { translateRegion } from 'src/utils'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) =>
  createStyles({
    cardHeader: {
      backgroundColor: theme.palette.background.paper,
      margin: theme.spacing(0, 2),
      marginTop: theme.spacing(1.25),
      borderRadius: 6,
      padding: theme.spacing(1.5),
      height: 160,
      maxWidth: 470,
      [theme.breakpoints.down('xs')]: {
        width: 'auto',
        height: 'auto',
      },
    },
    cardHeaderContent: {
      overflow: 'hidden',
    },
    cardHeaderAvatar: {
      height: theme.spacing(16),
      width: theme.spacing(16),
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        height: theme.spacing(6.75),
        width: theme.spacing(12),
        marginRight: theme.spacing(1.5),
      },
    },
    avatar: {
      width: '100%',
      height: '100%',
    },
    arrowRightIcon: {
      flexShrink: 0,
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    vectorAvatar: {
      width: 15,
      height: 18,
      backgroundColor: theme.palette.secondary.main,
    },
    vectorIcon: {
      '& path': {
        fill: theme.palette.secondary.contrastText,
      },
    },
    markButton: {
      backgroundColor: fade(theme.palette.secondary.main, 0.1),
    },
    address: {
      marginTop: theme.spacing(1),
      fontWeight: 400,
      wordBreak: 'break-all',
      textOverflow: 'ellipsis',
      fontSize: 18,
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      ' -webkit-line-clamp': 2,
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
    },
  }),
)

const ClinicCard = ({ authenticated, clinic, packages, price, currency }) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tB] = useCustomTranslation()
  const history = useHistory()

  const { addressFormat } = useAddressFormat()
  return (
    <Box>
      <CardHeader
        classes={{
          root: classes.cardHeader,
          content: classes.cardHeaderContent,
          avatar: classes.cardHeaderAvatar,
        }}
        avatar={
          <Avatar
            className={classes.avatar}
            variant="rounded"
            src={clinic?.cover}
            label={clinic?.[tB('name')]}
          >
            <ImageFillIcon />
          </Avatar>
        }
        title={
          <Box>
            <Typography variant="h5" component="div" noWrap>
              <Box color="grey.900" fontWeight="600" component="span">
                {clinic?.[tB('name')]}
              </Box>
            </Typography>
            <Typography>
              <Box component="span" color="grey.800" className={classes.address}>
                {addressFormat(clinic?.[tB('address')], t(translateRegion(clinic?.area)))}
              </Box>
            </Typography>
          </Box>
        }
        disableTypography
        onClick={() => {
          history.push(`/${i18n.language}/clinic/${clinic?.id}`, {
            packages: packages,
            currency: currency,
            price: price,
          })
        }}
      />
    </Box>
  )
}

export default ClinicCard
